"use client";

import { useState } from "react";

// Click-to-load Matterport tour: the 3D viewer (2MB+ and third-party cookies) only loads when asked for.
export default function TourEmbed({ src, title, image }) {
  const [on, setOn] = useState(false);
  if (on) {
    return <iframe src={`${src}&play=1`} title={title} allow="fullscreen; vr" style={{ width: "100%", aspectRatio: "16 / 9", border: 0 }} />;
  }
  return (
    <button type="button" className="tour-facade" onClick={() => setOn(true)} aria-label={`Start the ${title.toLowerCase()}`}>
      <img src={image} alt="Virtual tour of Lulu Wild, Brindleyplace" loading="lazy" />
      <span className="btn btn--solid">Start the virtual tour</span>
    </button>
  );
}
